
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

interface IProps {
  label: React.ReactNode;
  tools?: React.ReactNode[];
  isHovering: boolean;
}

export const TdsFormLabel = (props: IProps) => {
  const { t } = useTranslation();
  const { label, tools, isHovering } = props;
  const displayLabel = typeof label === 'string' ? t(label) : label;

  return <div className={'flex justify-between items-center w-full'}>
      <div>{displayLabel}</div>
    <div className={classnames({
      ['flex items-center justify-center gap-[4px]']: true,
      [styles.hovering]: !isHovering,
    })}>
      {tools?.map(item => item)}
      </div>
  </div>;
};
